import './card-review.scss';

export default () => {

};
